import { useTranslation } from "react-i18next";
import { LLM_MODEL_NAMES, type LLMModelName } from "@/api/types";
import { Label } from "@/components/ui/label";

export interface LlmModelsFieldProps {
  selected: LLMModelName[];
  hasError: boolean;
  onToggle: (model: LLMModelName, checked: boolean) => void;
}

export function LlmModelsField({
  selected,
  hasError,
  onToggle,
}: LlmModelsFieldProps) {
  const { t } = useTranslation();
  return (
    <div>
      <Label>{t("adminMeetingTypes.fields.llmModels")}</Label>
      <div className="flex flex-col gap-1">
        {LLM_MODEL_NAMES.map((m) => (
          <label key={m} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              data-testid={`llm-${m}`}
              checked={selected.includes(m)}
              onChange={(e) => onToggle(m, e.target.checked)}
            />
            {m}
          </label>
        ))}
      </div>
      {hasError ? (
        <p className="text-xs text-destructive">
          {t("adminMeetingTypes.errors.modelsRequired")}
        </p>
      ) : null}
    </div>
  );
}
